.activityIndicator {
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon path {
  fill: var(--row-normal-state-text-color);
}

.iconContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
}
